import { render, staticRenderFns } from "./AdminEditor.vue?vue&type=template&id=04ed8250&scoped=true"
import script from "./AdminEditor.vue?vue&type=script&lang=js"
export * from "./AdminEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ed8250",
  null
  
)

export default component.exports